// extracted by mini-css-extract-plugin
export default {"planConnector":"ConfirmStep_planConnector__x4Q5h","planConnectorIcon":"ConfirmStep_planConnectorIcon__RuylI"};